import axios from 'axios'

let baseURL = '';
if (process.env.NODE_ENV === 'development') {//开发
    // baseURL = 'http://kmzs.yvliang.com:9999/api/'
    baseURL = 'http://ihippoads.com:9999/api/'
} else if (process.env.NODE_ENV === 'production') {//线上
    baseURL = 'http://ihippoads.com:9999/api/'
}

let Axios = axios.create({
    baseURL: baseURL,
    timeout: 8000,
});

// get 需要的参数：url、params
export function get(url, params) {
    return new Promise((resolve, reject) => {
        Axios.get(url, {
            params: params
        })
            .then(res => {
                console.log('http.js的get方法调用');
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

// post 需要的参数：url、data
export function post(url, data) {
    return new Promise((resolve, reject) => {
        Axios.post(url, data)
            .then(res => {
                console.log('http.js的post方法调用');
                resolve(res)
            })
            .catch(res => {
                reject(res)
            })
    })
}

export default Axios;//把配置暴露给外面